import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/pages/Login/Login";
import Signup from "./components/pages/Signup/Signup";
import Otp from "./components/pages/Signup/Otp";
import Verifyotp from "./components/pages/Signup/Verifyotp";
import Layout from "./components/Common/Layout";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import Profile from "./components/pages/Profile/Profile";
import Uploadquestion from "./components/pages/UploadQuestion/Uploadquestion";
import Manageuser from "./components/pages/ManageUser/Manageuser";
import MasterSetting from "./components/MasterSetting/MasterSetting";

import MasterLevels from "./components/MasterSetting/MasterLevels";
import MasterQuestion from "./components/MasterSetting/MasterQuestion";
import MasterQuestionType from "./components/MasterSetting/MasterQuestionType";
import MasterLanguage from "./components/MasterSetting/MasterLanguage";
import MasterAuthor from "./components/MasterSetting/MasterAuthor";
import MasterConcept from "./components/MasterSetting/MasterConcept";
import MasterUniversity from "./components/MasterSetting/MasterUniversity";


function App() {
    return (
        <>
            <Router>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="upload-question" element={<Uploadquestion />} />
                        <Route path="manage-user" element={<Manageuser />} />
                        <Route path="user-profile" element={<Profile />} />
                        <Route path="/master-settings" element={<MasterSetting />} />
                        <Route path="/master-levels" element={<MasterLevels />} />
                        <Route path="/master-question" element={<MasterQuestion />} />
                        <Route path="/master-question-type" element={<MasterQuestionType />} />
                        <Route path="/master-language" element={<MasterLanguage />} />
                        <Route path="/master-author" element={<MasterAuthor />} />
                        <Route path="/master-concept" element={<MasterConcept />} />
                        <Route path="/master-university" element={<MasterUniversity />} />
                    </Route>
                    <Route path="/" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/otp" element={<Otp />} />
                    <Route path="/verify-otp" element={<Verifyotp />} />

                    {/* <Route path="admin-panel" element={<h1> Admin Panel</h1>}>
            <Route path="dashboard" element={<h1>dashboard</h1>} />
            <Route path="*" element={<h1>Not Found</h1>} />
          </Route> */}

                    <Route path="*" element={<h1>Not Found</h1>} />
                </Routes>
            </Router>
        </>
    );
}

export default App;
